import surfaceStore from '../store/surfaceStore';
import { DateRange } from 'owa-datetime-utils';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

export function canShowAgendaPane(): boolean {
    const { selectedDate, dateRangeType } = surfaceStore;
    return dateRangeType === DateRangeType.Month && !!selectedDate;
}

export function getSelectedDateDateRange(): DateRange {
    const { selectedDate } = surfaceStore;
    return {
        start: selectedDate,
        end: selectedDate,
    };
}
